<template>
  <v-card>
    <v-card-title>
      Blogs
      <v-spacer v-if="user.admin == true"></v-spacer>
      <v-btn v-if="user.admin == true" small color="red darken-2" dark @click="deleteBlogs" >Delete Selected</v-btn>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table :headers="(user.admin== true) ? headers : (user.manager== true) ? managerHeaders: editorHeaders" :items="blogs" :pagination.sync="pagination" v-model="selected" select-all item-key="_id" class="elevation-1" :total-items="amount" :rows-per-page-items="listSize">
      <template slot="headers" slot-scope="props">
        <tr>
          <th v-if="user.admin == true">
            <v-checkbox
              primary
              hide-details
              @click.native="toggleAll"
              :input-value="props.all"
              :indeterminate="props.indeterminate"
            ></v-checkbox>
          </th>
          <th v-for="header in props.headers" :key="header.text"
            :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '', header.text=='Action' ? 'text-xs-center' : 'text-xs-left']"
            @click="changeSort(header.value)"
          > 
            {{ header.text }}
            <v-icon>arrow_upward</v-icon>
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr :active="props.selected" @click="props.selected = !props.selected">
          <td v-if="user.admin == true">
            <v-checkbox
              primary
              hide-details
              :input-value="props.selected"
            ></v-checkbox>
          </td>
          <td>{{ props.item.title }}</td>
          <td class>{{ props.item.createdAt | moment("Do MMM YYYY") }}</td>
          <td class="text-xs-center">
            <v-btn color="blue darken-2" v-if="props.item.status!='Active'" small flat @click="activateModal(props.item)">
              Activate
            </v-btn>

             <v-btn color="red" v-if="props.item.status=='Active'" small flat @click="deactivateModal(props.item)">
              Deactivate
            </v-btn>
          </td>
          <td v-if="user.admin== true || user.manager == true || user.editor == true">
            <v-btn icon @click="editModal(props.item)">
              <v-icon color="orange darken-2">edit</v-icon>
            </v-btn>
          </td>
          <td class v-if="user.admin== true">
            <v-btn icon @click="deleteModal(props.item)">
              <v-icon color="red">delete</v-icon>
            </v-btn>
          </td>
        </tr>  
      </template>
      <v-alert
        v-slot:no-results
        :value="true"
        color="error"
        icon="warning"
      >Your search for "{{ search }}" found no results.</v-alert>
    </v-data-table>

    <!-- delete dialog -->
    <v-dialog v-model="delete_dialog" max-width="750px">
      <v-toolbar class="red" dark dense>
        <v-toolbar-title>Delete Blog</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="delete_dialog=false">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 class="pa-2">
              <h5>Are you sure you want to delete this blog?</h5>
            </v-flex>

            <v-flex xs12>
              <v-text-field label="Title" v-model="dataItem.title"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field label="Slug" v-model="dataItem.url"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                v-model="dataItem.short_description"
                label="Short Description"
              ></v-textarea>
            </v-flex>
            <v-flex xs12>
              <ckeditor v-model="dataItem.description" label="Description" :editor="editor" :config="editorConfig"></ckeditor>
            </v-flex>
            <v-flex v-if="dataItem.blogVideo"  xs12 sm3 >
                <video :src="`${host}/uploads/blog/video/${dataItem.blogVideo}`" style="max-width:100%; height:auto" controls=""></video>
            </v-flex>
            <v-flex xs12>
              <v-text-field label="Video Title" v-model="dataItem.video_title"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field label="Meta Title" v-model="dataItem.meta_title"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-textarea label="Meta Description" v-model="dataItem.meta_description"></v-textarea>
            </v-flex>

            <v-flex xs12>
              <v-btn color="red" class="right" small dark @click="deleteBlog" :loading="loader">
                <v-icon left>delete</v-icon>Yes
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- end of delete  -->


    <!-- activate dialog -->
    <v-dialog v-model="activate_dialog" max-width="750px">
      <v-toolbar class="primary" dark dense>
        <v-toolbar-title>Activate Blog</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="activate_dialog=false">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 class="pa-2">
            </v-flex>

            <v-flex xs12>
              <v-text-field label="Title" v-model="dataItem.title"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field label="Slug" v-model="dataItem.url"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                v-model="dataItem.short_description"
                label="Short Description"
              ></v-textarea>
            </v-flex>
            <v-flex xs12>
              <ckeditor v-model="dataItem.description" label="Description" :editor="editor" :config="editorConfig"></ckeditor>
            </v-flex>
            <v-flex v-if="dataItem.blogVideo"  xs12 sm3 >
                <video :src="`${host}/uploads/blog/video/${dataItem.blogVideo}`" style="max-width:100%; height:auto" controls=""></video>
            </v-flex>
            <v-flex xs12>
              <v-text-field label="Video Title" v-model="dataItem.video_title"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field label="Meta Title" v-model="dataItem.meta_title"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-textarea label="Meta Description" v-model="dataItem.meta_description"></v-textarea>
            </v-flex>

            <v-flex xs12>
              <v-btn color="primary" class="right" small dark @click="activate" :loading="loader">
                <v-icon left>thumb_up</v-icon> Activate
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- end of activate modal  -->


        <!-- deactivate dialog -->
    <v-dialog v-model="deactivate_dialog" max-width="750px">
      <v-toolbar class="orange darken-2" dark dense>
        <v-toolbar-title>Deactivate Blog</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="deactivate_dialog=false">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 class="pa-2">
            </v-flex>

            <v-flex xs12>
              <v-text-field label="Title" v-model="dataItem.title"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field label="Slug" v-model="dataItem.url"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                v-model="dataItem.short_description"
                label="Short Description"
              ></v-textarea>
            </v-flex>
            <v-flex xs12>
              <ckeditor v-model="dataItem.description" label="Description" :editor="editor" :config="editorConfig"></ckeditor>
            </v-flex>
            <v-flex v-if="dataItem.blogVideo"  xs12 sm3 >
                <video :src="`${host}/uploads/blog/video/${dataItem.blogVideo}`" style="max-width:100%; height:auto" controls=""></video>
            </v-flex>
            <v-flex xs12>
              <v-text-field label="Video Title" v-model="dataItem.video_title"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field label="Meta Title" v-model="dataItem.meta_title"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-textarea label="Meta Description" v-model="dataItem.meta_description"></v-textarea>
            </v-flex>

            <v-flex xs12>
              <v-btn color="orange darken-2" class="right" small dark @click="deactivate" :loading="loader">
                <v-icon left>thumb_down</v-icon> Deactivate
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- end of deactivate modal  -->

    <!-- Editor editing -->
    <v-dialog v-model="editDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-toolbar flat dense color="primary" dark>
        <v-toolbar-title class="title">Edit Blog</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon class="mx-0" @click.native="editDialog = false">
          <v-icon color="white">clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  v-validate="'required'"
                  :error-messages="errors.collect('title')"
                  data-vv-name="firstName"
                  v-model="editItem.title"
                  label="Title"
                  type="text"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-validate="'required'"
                  :error-messages="errors.collect('url')"
                  data-vv-name="url"
                  v-model="editItem.url"
                  label="Slug"
                  type="text"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  v-validate="'required'"
                  :error-messages="errors.collect('short_description')"
                  data-vv-name="short_description"
                  v-model="editItem.short_description"
                  label="Short Description"
                ></v-textarea>
              </v-flex>
              <v-flex xs12>
                <ckeditor v-model="editItem.description" id="description"
                  data-vv-name="description"  label="Description" :editor="editor" :config="editorConfig"></ckeditor>
              </v-flex>
              <v-flex xs12 sm12 v-if="editItem.blogVideo">
                <label>Video</label>
              </v-flex>
              <v-flex xs12 sm3 id="showvideo" v-if="editItem.blogVideo">
                <v-btn icon @click="deleteVideo()">
                    <v-icon color="red">clear</v-icon>
                  </v-btn>
                  <video style="width: 150px;" :src="`${host}/uploads/blog/video/${editItem.blogVideo}`" controls=""></video>
              </v-flex>
              <v-flex xs12 sm12>
                  <label>Only Video file Upload (Maximum size 15MB per file)</label>
                  <v-alert :value="true" v-model="videofileerror" type="error" class="py-2 error" dismissible>Uploaded files must be videos in format & not to exceed 15MB</v-alert>
                  <file-upload @image="setVideoUrl"></file-upload>
                </v-flex>

                <v-flex xs12 sm8 v-if="videoUrl">
                    <video
                      v-if="videoUrl"
                      :src="videoUrl"
                      style="width: 150px;" controls=""
                    ></video>
                    <v-btn icon @click="removeVideo()">
                      <v-icon color="red">clear</v-icon>
                    </v-btn>
                </v-flex>
              <v-flex xs12>
                <v-text-field
                  data-vv-name="video_title"
                  v-model="editItem.video_title"
                  label="Video Title"
                  type="text"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  data-vv-name="meta_title"
                  v-model="editItem.meta_title"
                  label="Meta Title"
                  type="text"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  data-vv-name="meta_description"
                  v-model="editItem.meta_description"
                  label="Meta Description"
                ></v-textarea>
              </v-flex>
              <v-flex xs12>
                <v-btn class="primary" @click="save" :loading="loader">
                  <v-icon left>save</v-icon>Save
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End -->

  </v-card>
</template>

<script>
import Snackbar from "@/components/global/snackbar.vue";
import { mapGetters } from "vuex";
import { trimDescription } from "@/common/methods.js";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import FileUpload from "@/components/shared/file-uploader.vue";
export default {
  components: {
    CKEditor,
    Snackbar,
    FileUpload
  },
  computed: {
    ...mapGetters(["host"]),
    ...mapGetters(["user"])
  },
  /*props: {
    blogs: {
      type: Array,
      default: [],
      required: true
    }
  },*/
  data() {
    return {
      search: "",
      delete_dialog: false,
      activate_dialog: false,
      deactivate_dialog: false,
      pagination: {rowsPerPage: 25,page: 1, sortBy: 'title'},
      dataItem: {},
      listSize: [5,10,25,50,100,{"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
      loader: false,
      headers: [
        {
          text: "Title",
          align: "left",
          sortable: false,
          value: "title"
        },
        { text: "Date Created", value: "createdAt" },
        { text: "Action", value: "activation", class: "text-xs-center" },
        { text: "Edit", value: "Edit" },
        { text: "Delete", value: "action" }
      ],
      editorHeaders: [
        {
          text: "Title",
          align: "left",
          sortable: false,
          value: "title"
        },
        { text: "Date Created", value: "createdAt" },
        { text: "Action", value: "activation", class: "text-xs-center" },
        { text: "Edit", value: "Edit" },
      ],
      managerHeaders: [
        {
          text: "Title",
          align: "left",
          sortable: false,
          value: "title"
        },
        { text: "Date Created", value: "createdAt" },
        { text: "Action", value: "activation", class: "text-xs-center" },
        { text: "Edit", value: "Edit" },
      ],
      editDialog: false,
      editItem: {},
      blogError: '',
      selected: [],
      editor: ClassicEditor,
      editorConfig: {
        link: { addTargetToExternalLinks: true },
        image: {
            styles: [
                'alignLeft', 'alignCenter', 'alignRight'
            ],
            resizeOptions: [
                {
                    name: 'imageResize:original',
                    label: 'Original',
                    value: null
                },
                {
                    name: 'imageResize:50',
                    label: '50%',
                    value: '50'
                },
                {
                    name: 'imageResize:75',
                    label: '75%',
                    value: '75'
                }
            ],
            toolbar: [
                'imageStyle:alignLeft', 'imageStyle:alignCenter', 'imageStyle:alignRight',
                '|',
                'imageResize',
                '|',
                'imageTextAlternative',
                '|',
                'linkImage'
            ]
        }
      },
      amount: 0,
      blogs: [],
      selected: [],
      videoImage: null,
      videoUrl: null,
      videofileerror: false,
      video_title: null
    };
  },
  methods: {
    editModal(item) {
      this.editItem = Object.assign({}, item);
      this.editDialog = true;
      this.blogError = '';
    },
    deleteModal(item) {
      this.dataItem = Object.assign({}, item);
      this.delete_dialog = true;
    },
    activateModal(item) {
      this.dataItem = Object.assign({}, item);
      this.activate_dialog = true;
    },
    deactivateModal(item) {
      this.dataItem = Object.assign({}, item);
      this.deactivate_dialog = true;
    },
    deleteBlog() {
      this.loader = true;
      const data = this.dataItem;
      const self = this;
      const res = this.$store
        .dispatch("post", { url: "/blog/delete", data })
        .then(res => {
          if (res.state) {
            self.loader = false;
            location.reload();
          }
        })
        .finally(() => {});
    },
    activate() {
      this.loader = true;
      const data = this.dataItem;
      const self = this;
      const res = this.$store
        .dispatch("post", { url: "/blog/activate", data })
        .then(res => {
          if (res.state) {
            self.loader = false;
            location.reload();
          }
        })
        .finally(() => {});
    },
    deactivate() {
      this.loader = true;
      const data = this.dataItem;
      const self = this;
      const res = this.$store
        .dispatch("post", { url: "/blog/deactivate", data })
        .then(res => {
          if (res.state) {
            self.loader = false;
            location.reload();
          }
        })
        .finally(() => {});
    },
    save() {
      const blogData = this.editItem;
      //video files
      const formData = new FormData();
      if(this.videoImage != null) {
        const cm_file = this.videoImage;
        let cbytes = this.videoImage.size;
        let cmimeType = this.videoImage.type;
        let allowedMimeType = ['video/x-flv', 'video/mp4', 'application/x-mpegURL', 'video/MP2T', 'video/3gpp', 'video/quicktime', 'video/x-msvideo', 'video/x-ms-wmv'];
        if(allowedMimeType.includes(cmimeType) & cbytes<=15*1024*1024) {
          formData.append("blogVideo", this.videoImage);
        }
      }
      formData.append("options", JSON.stringify(blogData));
      const data = formData;
      this.loader = true;
      const self = this;
      const res = this.$store
        .dispatch("put", { url: "/blog/update/" + this.editItem._id, data })
        .then(res => {
          self.loader = false;
          location.reload();
      });
    },
    toggleAll () {
      if (this.selected.length) { 
        this.selected = []
      } else {
        this.selected = this.blogs.slice()
      }
    },
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    fetchData() {
        return new Promise((resolve, reject) => {
            let search = this.search.trim().toLowerCase();
            const {rowsPerPage, page} = this.pagination;
            if(search !== '') {
              search = `/`+search;  
            }
            let sortBy = '/'+this.pagination.sortBy;
            let order  = -1;
            if(this.pagination.descending == false) {
              order = 1;
            }
            let sortOrder = '/'+order;
            this.$store.dispatch("get", `/blog/admin/get`+sortBy+sortOrder+'/'+page+`/`+rowsPerPage+search).then(res => {
              this.blogs = res.blogs;
              const {
                  sortBy,
                  descending,
                  page,
                  rowsPerPage
              } = this.pagination;
              this.amount = res.amount;
              resolve();
            });
        });
    },
    toggleAll () {
      if (this.selected.length) { 
        this.selected = []
      } else {
        this.selected = this.fundis.slice()
      }
    },
    deleteBlogs() {
      const blogs = [];
      this.selected.forEach((value, index) => {
        blogs.push(value._id);
      });
      this.loader = true;
      const data = {
        blogs: blogs
      };
      const self = this;
      const res = this.$store
        .dispatch("post", { url: "/blog/all/delete", data })
        .then(res => {
          if (res.state) {
            self.loader = false;
            location.reload();
          }
        })
        .finally(() => {});
    },
    deleteVideo() {
      this.editItem.blogVideo = '';
      const data = { blogVideo: this.editItem.blogVideo };
      const self = this;
      const id = this.editItem._id;
      const res = this.$store
        .dispatch("put", { url: "/blog/delete/video/" + id, data })
        .then(res => {
          //location.reload();
        })
        .finally(() => {});
    },
    setVideoUrl({ image, imageUrl }) {
      this.videofileerror = false;
      const bytes = (this.calculateImageSize(imageUrl));
      let mimeType = imageUrl.match(/[^:]\w+\/[\w-+\d.]+(?=;|,)/)[0];
      let allowedMimeType = ['video/x-flv', 'video/mp4', 'application/x-mpegURL', 'video/MP2T', 'video/3gpp', 'video/quicktime', 'video/x-msvideo', 'video/x-ms-wmv']
      if(allowedMimeType.includes(mimeType) & bytes<=15) {
        this.videoImage = image;
        this.videoUrl = imageUrl;
        this.videofileerror = false;
      } else {
        this.videofileerror = true;
      }
      
    },
    removeVideo(key) {
      this.videoUrl = null;
      this.videoImage = null;
    },
    calculateImageSize(base64String){
      let padding, inBytes, base64StringLength;
      if(base64String.endsWith("==")) padding = 2;
      else if (base64String.endsWith("=")) padding = 1;
      else padding = 0;

      base64StringLength = base64String.length;
      inBytes =(base64StringLength / 4 ) * 3 - padding;
      this.kbytes = inBytes / 1000;
      return this.kbytes / 1000;
    },
  },
  watch: {
    pagination: {
        handler() {
            this.fetchData();
        },
        deep: true
    },
    search() {
        this.pagination.page = 1;
        this.pagination.rowsPerPage = 25;
        this.fetchData();
    }
  },
  /*mounted() {
        this.fetchData();
  }*/
};
</script>